"use client"

import React from 'react'
import { Button } from '../../../shared/components/ui/button'
import Heading from '../../../shared/components/ui/typography/heading'
import { ChatBubbleIcon } from '@radix-ui/react-icons'
import { CHAT_ITEM_LIST } from '../constants/content'
import ChatItem from './chat-item'
import { useActiveChat } from '../context/active-chat-context'
import { cn } from '../../../shared/lib/utils'
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from '../../../shared/components/ui/dialog'
import TextInput from '../../../shared/components/inputs/text-input'
import { Search } from 'lucide-react'

function ChatList() {

    const { showChatDetails, handleShowChatDetails } = useActiveChat()
    
    return (
        <div 
            className={cn(
                "space-y-3 min-h-full grid grid-rows-[auto_1fr] lg:border-r",
                {
                    'hidden': showChatDetails
                }
            )}
        >
            <div className="p-5 space-y-5">
                <Heading>Messages</Heading>
                <Dialog>
                    <DialogTrigger asChild>
                        <Button className='h-10'>
                            <ChatBubbleIcon />
                            Start Chat
                        </Button>
                    </DialogTrigger>
                    <DialogContent>
                        <div className='space-y-1 text-center'>
                            <DialogTitle className='text-2xl'>Search Contact</DialogTitle>
                            <DialogDescription>Quickly locate and connect with individuals using the search feature.</DialogDescription>
                        </div>
                        <div className="flex flex-col items-center justify-center space-y-5">
                            <TextInput 
                                placeholder="Search for a contact"
                                className="border-input"
                                label='Search Contact'
                                rightIcon={<Search className='text-gray-400 w-7' />}
                                labelClassName='text-sm'
                            />
                        </div>
                    </DialogContent>
                </Dialog>
            </div>
            <div className="pb-2 overflow-y-auto">
                {CHAT_ITEM_LIST.map((item, index) => (
                    <ChatItem key={`${item.id}-chat-list-item-${index}`} {...item} />
                ))}
            </div>
        </div>
    )
}

export default ChatList